import { combineReducers } from 'redux';
import userReducer from 'redux/reducers/userReducer';
import caseReducer from 'redux/reducers/caseReducer';
import configReducer from 'redux/reducers/configReducer';
import reportReducer from 'redux/reducers/reportReducer';
import assessmentReducer from 'redux/reducers/assessmentReducer';
import carePlanReducer from 'redux/reducers/carePlanReducer';
import careTeamReducer from 'redux/reducers/careTeamReducer';
import consultReducer from 'redux/reducers/consultReducer';
import modalReducer from 'redux/reducers/modalReducer';

export default combineReducers({
  user: userReducer,
  caseData: caseReducer,
  config: configReducer,
  report: reportReducer,
  assessment: assessmentReducer,
  carePlan: carePlanReducer,
  careTeam: careTeamReducer,
  consult: consultReducer,
  modal: modalReducer,
});
